import translate from "@insite/client-framework/Translate";
import Button from "@insite/mobius/Button";
import Modal from "@insite/mobius/Modal";
import Typography from "@insite/mobius/Typography";
import React from "react";
import styled from "styled-components";

type Props = {
    isOpen: boolean;
    handleClose(): void;
    onConfirm(includePrices: boolean): void;
};

const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
`;

const ButtonRow = styled.div`
    display: flex;
    justify-content: center;
`;

const YesButton = styled(Button)`
    margin-right: 24px;
`;

const PrintIncludePricesModal: React.FC<Props> = ({ isOpen, handleClose, onConfirm }) => {
    const handleYes = () => {
        handleClose();
        onConfirm(true);
    };

    const handleNo = () => {
        handleClose();
        onConfirm(false);
    };

    return (
        <Modal headline={translate("Print Project")} isOpen={isOpen} handleClose={handleClose} size={400}>
            <ModalContent>
                <Typography variant="p">{translate("Do you want to include prices?")}</Typography>
                <ButtonRow>
                    <YesButton variant="primary" onClick={handleYes}>
                        {translate("YES")}
                    </YesButton>
                    <Button variant="primary" onClick={handleNo}>
                        {translate("NO")}
                    </Button>
                </ButtonRow>
            </ModalContent>
        </Modal>
    );
};

export default PrintIncludePricesModal;
